import { render, staticRenderFns } from "./FilterBadges.vue?vue&type=template&id=53b67bf1&scoped=true"
import script from "./FilterBadges.vue?vue&type=script&lang=js"
export * from "./FilterBadges.vue?vue&type=script&lang=js"
import style0 from "./FilterBadges.vue?vue&type=style&index=0&id=53b67bf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b67bf1",
  null
  
)

export default component.exports